import { useEffect } from 'react';

import type { AssetsSegmentSchemaWithIdPatched } from '@iconik-io/iconik-api/src/schema_patched/assets_segments';

import { fetchCommentAttachmentUrls } from '../../../../../redux/comment_attachments/thunks';
import { useAppDispatch } from '../../../../../redux/redux_hooks';

type SegmentWithAttachments = Pick<
  AssetsSegmentSchemaWithIdPatched,
  'id' | 'asset_id' | 'has_attachments' | 'attachments'
>;

/**
 * The uploaded attachments of a comment. Their signed urls are fetched once
 * and kept on the segment entity, which survives the virtualized list
 * remounting its rows.
 */
export function useSegmentAttachments(segment: SegmentWithAttachments) {
  const dispatch = useAppDispatch();
  const attachments = segment.attachments ?? [];
  const needsUrls =
    Boolean(segment.has_attachments) &&
    (attachments.length === 0 ||
      attachments.some((attachment) => !attachment.url));

  useEffect(() => {
    if (needsUrls) {
      dispatch(fetchCommentAttachmentUrls(segment.asset_id, segment.id));
    }
  }, [needsUrls, segment.asset_id, segment.id]);

  return attachments.filter((attachment) => attachment.status === 'CLOSED');
}
